<div>
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Question" class="table-header-title text-start">{{'faqManager.question' | translate}}</th>
                    <th id="LastModified" class="table-header-title text-center">{{'faqManager.lastModified' | translate}}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let faq of frequentlyAskedQuestions,let i = index">
                    <tr class="row-container">
                        <td HJSuppress id="Question" class="column-content table-main-td text-start" 
                            (click)="editDetails(faq.frequentlyAskedQuestionId)">
                            {{faq.question}}
                        </td>
                        <td HJSuppress id="LastModified" class="column-content text-center">
                            {{faq.lastModified | localizedDate}}
                        </td>
                        <td class="text-end">
                            <div class="buttons-container d-inline-flex align-items-center gap-2">
                                <div class="d-flex align-items-center gap-2">
                                    <button class="btn edit-btn p-2"
                                        (click)="editDetails(faq.frequentlyAskedQuestionId)">
                                        <i class="app-icon icon icon-edit icon-lg text-secondary"></i>
                                    </button>
                                    <button class="btn delete-btn custom-delete-btn p-2"
                                        (click)="deleteFrequentlyAskedQuestion(faq.frequentlyAskedQuestionId)">
                                        <i class="app-icon icon icon-delete icon-lg"></i>
                                    </button>
                                </div>
                                <div class="d-flex flex-column">
                                    <button class="btn order-btn" [disabled]="i+1===firstQuestionOrder || isFiltered"
                                        (click)="moveFrequentlyAskedQuestionUp(i)">
                                        <i class="app-icon icon icon-chevron-up icon-lg text-secondary"></i>
                                    </button>
                                    <button class="btn order-btn" [disabled]="i+1===lastQuestionOrder || isFiltered"
                                        (click)="moveFrequentlyAskedQuestionDown(i)">
                                        <i class="app-icon icon icon-chevron-down icon-lg text-secondary"></i>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>